import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { common } from '@qwyk/models';
import {
    BackendQuery,
    Shipment,
    ShipmentData,
    ShipmentState,
    ShipmentTrackingRequest,
    ShipmentTrackingRequestResponse,
} from './shipments.models';

export const ShipmentsActions = createActionGroup({
    source: 'Portals/Shipments',
    events: {
        'Load Shipments': props<{ query: BackendQuery }>(),
        'Load Shipments Success': props<{
            shipments: Shipment[];
            customFields: common.CustomFieldDefinition[];
            customViews: common.CustomView[];
            backendPagination?: common.PaginationMeta;
            cachedAt?: string;
        }>(),
        'Load Shipments Failure': props<{ error: Error }>(),

        'Load Draft Shipments': props<{ query: BackendQuery, includeStates: ShipmentState[] }>(),
        'Load Draft Shipments Success': props<{
            shipments: Shipment[];
            customFields: common.CustomFieldDefinition[];
            customViews: common.CustomView[];
            cachedAt?: string;
        }>(),
        'Load Draft Shipments Failure': props<{ error: Error }>(),

        'Load Shipment': props<{ shipmentId: string }>(),
        'Load Shipment Success': props<{ shipment: Shipment }>(),
        'Load Shipment Failure': props<{ error: Error }>(),

        'Search Shipments': props<{ query: unknown }>(),

        'Select Shipment': props<{ selectedId: string }>(),
        'Unselect Shipment': emptyProps(),

        'Reset Load Shipments Query': emptyProps(),

        'Update Shipment References': props<{ shipmentId: string; update: Partial<Shipment> }>(),
        'Update Shipment Partially Success': props<{ shipmentId: string; update: Partial<Shipment> }>(),
        'Update Shipment Partially Failure': props<{ error: Error }>(),

        'Generate Shipment Pdf': props<{ shipmentId: string }>(),
        'Generate Shipment Pdf Success': props<{ blob: Blob }>(),
        'Generate Shipment Pdf Failure': props<{ error: Error }>(),

        'Send Tracking Request': props<{ shipmentId: string; trackingRequest: ShipmentTrackingRequest }>(),
        'Send Tracking Request Success': props<{ shipmentId: string; response: ShipmentTrackingRequestResponse }>(),
        'Send Tracking Request Failure': props<{ error: Error }>(),

        'Cancel Tracking Request': props<{ shipmentId: string }>(),
        'Cancel Tracking Request Success': props<{ shipmentId: string; response: ShipmentTrackingRequestResponse }>(),
        'Cancel Tracking Request Failure': props<{ error: Error }>(),

        'Update Shipment Data Transport': props<{ shipmentId: string; changes: Partial<ShipmentData> }>(),
        'Update Shipment Data Transport Success': props<{ shipmentId: string; data: ShipmentData }>(),
        'Update Shipment Data Transport Failure': props<{ error: Error }>(),

        'Update Shipment Data References': props<{ shipmentId: string; changes: Partial<ShipmentData> }>(),
        'Update Shipment Data References Success': props<{ shipmentId: string; data: ShipmentData }>(),
        'Update Shipment Data References Failure': props<{ error: Error }>(),

        'Assign Shipment Operator': props<{ shipmentId: string; operatorId: number }>(),
        'Assign Shipment Operator Success': props<{ shipment: Shipment }>(),
        'Assign Shipment Operator Failure': props<{ error: Error }>(),

        'Complete Shipment': props<{ shipmentId: string }>(),
        'Complete Shipment Success': props<{ shipment: Shipment }>(),
        'Complete Shipment Failure': props<{ error: Error }>(),

        'Cancel Shipment': props<{ shipmentId: string }>(),
        'Cancel Shipment Success': props<{ shipment: Shipment }>(),
        'Cancel Shipment Failure': props<{ error: Error }>(),

        'Update Shipment Name': props<{ shipmentId: string; update: Partial<Shipment> }>(),

        'Tag Shipment': props<{ entityId: string; tag: common.CustomTag }>(),
        'Remove Tag from Shipment': props<{ entityId: string; tagId: string }>(),
        'Update Tag In Shipment': props<{ tag: common.CustomTag; tagId?: string; entityId?: string; request?: Partial<common.CustomTag> }>(),

        'Load Sys States': props<{ forceRefresh?: boolean }>(),
        'Load Sys States Success': props<{ sys_states: ShipmentState[] }>(),
        'Load Sys States Failure': props<{ error: Error }>(),

        'Reset Action': emptyProps(),
        'Force Refresh Shipments': emptyProps(),
        'Dismiss Error': emptyProps(),
        'Reset Pagination Action': emptyProps(),

        // Filter Suggestions Actions - PRESERVE FOR WEBWORKER FUNCTIONALITY
        'Calculate Filter Suggestions': props<{ data: any[]; columns: string[] }>(),
        'Calculate Filter Suggestions Success': props<{ suggestions: { [column: string]: string[] } }>(),
        'Calculate Filter Suggestions Failure': props<{ error: Error }>(),
    },
});
